export default "__VITE_ASSET__B_iI0wDe__"